export enum CreditCardFormActionEnum {
    CANCEL,
    UPGRADE,
    ADD_CARD
}